<style></style>
<template>
  <div>
    <div class="content-box">
      <div class="support-index" :class="{ 'show-ticket-content': seleccionada }">
        <div class="support-tickets">
          <div class="support-tickets-header">
            <div class="tickets-control">
              <h6>Despachos</h6>
            </div>
            <div class="tickets-filter">
              <button
                type="button"
                data-toggle="modal"
                data-target="#modalCrearTarea"
                class="btn btn-dark btn-md btn-block"
              >
                Buscar Picking Despacho <i class="fas fa-search"></i>
              </button>
            </div>
          </div>

          <div>
            <div
              class="modal fade"
              id="modalCrearTarea"
              tabindex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h6 class="modal-title">Buscar picking despacho</h6>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="col-12">
                      <label v-if="current.scan_barra == true">Barra de pedido</label>
                      <label v-if="current.scan_barra == false"># de pedido</label>
                      <input
                        focus
                        type="text"
                        v-on:keyup.enter="buscarPicking()"
                        class="form-control"
                        v-model="current.barra"
                        ref="barrax"
                      />
                      <small class="text-danger" v-if="errors && errors.barra">{{
                        errors.barra[0]
                      }}</small>
                    </div>
                    <br />
                    <div v-if="current.scan_barra == false" class="col-12">
                      <TiendaSelectComponent
                        titulo="Seleccionar una tienda"
                        :current="current"
                      />
                    </div>
                    <div
                      v-if="current.scan_barra == false && current.tienda"
                      class="col-12"
                    >
                      <CajaSelectComponent :tienda="current.tienda" :current="current" />
                    </div>
                    <br />
                    <div class="col-12">
                      <button
                        @click="buscarPicking()"
                        type="button"
                        class="btn btn-success btn-lg btn-block"
                      >
                        Aceptar
                        <i class="fas fa-check"></i>
                      </button>
                      <br />
                    </div>
                    <span style="font-size: 20px" class="font-weight-bold"
                      >Buscar por:
                    </span>
                    <button
                      @click="cambiarTipoScan()"
                      class="btn btn-dark btn-lg btn-md btn-block"
                      v-if="current.scan_barra == true"
                    >
                      Número y tienda
                    </button>
                    <button
                      @click="cambiarTipoScan()"
                      class="btn btn-dark btn-lg btn-block"
                      v-if="current.scan_barra == false"
                    >
                      # barra
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="support-ticket-content-w"
          style="background-color: rgb(249, 249, 249)"
        >
          <div
            class="support-ticket-content"
            style="background-color: rgb(249, 249, 249)"
          >
            <div
              class="support-ticket-content-header mb-0"
              v-if="seleccionada"
              style="display: block"
            >
              <br />
              <a class="back-to-index" href="#" @click="ResetSelect()">
                <i class="os-icon os-icon-arrow-left"></i>
                <span style="color: #71bf44">Atrás</span>
              </a>
              <div style="text-align: center">
                <span class="ticket-header" style="font-size: 18px"
                  >Despacho de Pedido</span
                >
                <span style="font-size: 18px"> #{{ seleccionada.numero }}</span>
                <br />
                <span
                  v-bind:class="{
                    'badge badge-danger': seleccionada.estado == '9',
                    'badge badge-success': seleccionada.estado == 'I',
                    'badge badge-info ': seleccionada.estado == 'B',
                    'badge badge-warning': seleccionada.estado == 'C',
                    'badge badge-dark': seleccionada.estado == 'H',
                    'badge badge-dark':
                      seleccionada.estado == '9' &&
                      validacion_despacho.estado_str == 'Finalizado',
                  }"
                  >{{ validacion_despacho.estado_str }}</span
                >
              </div>
              <div>
                <br />
                Picking Status:
                <span v-if="validacion_despacho && validacion_despacho.estado"
                  ><b>{{ validacion_despacho.estado_str }}</b></span
                >
                <br />
                Tienda:
                <b
                  >{{ seleccionada.tienda.nombre }} ({{ seleccionada.tienda.codigo }})
                </b>
                <br />
                Fecha:
                <b>{{ seleccionada.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss a") }}</b>
                <span v-if="seleccionada.ruta_despacho">
                  <br />
                  <b>Ruta: #{{ seleccionada.ruta_despacho }}</b>
                </span>
              </div>
              <span>
                Cliente:
                <b
                  >{{ seleccionada.cliente.nombre }} ({{ seleccionada.cliente.nit }})</b
                ></span
              >
              <br />
              <!-- Boton de acciones flotantes start  -->
              <div class="fab">
                <div @click="abrirModalOpciones()" class="btn-round">
                  <i id="addIcon"><i class="fas fa-bars"></i></i>
                </div>
              </div>
              <!-- Boton de acciones flotantes END  -->
              <ModalPickearComponent
                :despachoe="seleccionada"
                :picking="validacion_despacho"
                @refreshCurrent="refreshDespachoE(seleccionada.id)"
              />
              <ModalAsignarPlacaComponent
                :despachoe="seleccionada"
                :placasList="placasAsignadas"
                @refreshCurrent="RefreshListaPlacas()"
              />
            </div>
            <br />
            <button @click="refreshDespachoE()" class="btn btn-sm btn-info">
              Actualizar Info. <i class="fas fa-sync"></i>
            </button>
            <hr />
            <EnvioDespachoDetalleComponent
              :despachod="detalle_despacho"
              :despachoe="validacion_despacho"
              @refreshDetalle="refreshDespachoE"
            />
            <ExistenciasModalComponent
              :seleccionada="seleccionada"
              :existencias="existencias"
            />
          </div>
        </div>
        <div
          aria-hidden="true"
          class="modal fade"
          id="modalOpciones"
          role="dialog"
          tabindex="-1"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div v-if="validacion_despacho" class="modal-body">
                <button
                  class="btn btn-sm btn-block btn-info"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  @click="finalizarDespacho()"
                  :disabled="validacion_despacho.estado != 'B'"
                >
                  <div class="activity-avatar">
                    <i class="fa fa-check fa-1x"></i>
                  </div>
                  <div class="activity-info">
                    <span class="font-weight-bold">Finalizar Despacho</span>
                  </div>
                </button>
                <button
                  class="btn btn-sm btn-block btn-danger"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  :disabled="validacion_despacho.estado != 'C'"
                  @click="facturarDespacho()"
                >
                  <div class="activity-avatar">
                    <i class="fas fa-cash-register"></i>
                  </div>
                  <div class="activity-info">
                    <span class="font-weight-bold">Facturar Pedido</span>
                  </div>
                </button>
                <hr />
                <button
                  class="activity-box btn-sm btn-block"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  :disabled="!(validacion_despacho.estado == 'B')"
                  @click="modalAsignarPlaca()"
                >
                  <div class="activity-info">
                    <span class="font-weight-bold"
                      >Asignar placa &nbsp; <i class="fas fa-truck-pickup float-right"></i
                    ></span>
                  </div>
                </button>
                <button
                  class="activity-box btn-sm btn-block"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  :disabled="!(validacion_despacho.estado == 'B')"
                  @click="abrirModalPlaca()"
                >
                  <div class="activity-info">
                    <span class="font-weight-bold"
                      >Placas asignadas &nbsp; <i class="fas fa-list float-right"></i
                    ></span>
                  </div>
                </button>
                <button
                  class="activity-box btn-sm btn-block"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  @click="verInventarioDeEstacion()"
                >
                  <div class="activity-info">
                    <span class="font-weight-bold"
                      >Inventario en posición&nbsp;
                      <i class="fas fa-pallet float-right"></i
                    ></span>
                  </div>
                </button>
                <button
                  class="activity-box btn-sm btn-block"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  :disabled="validacion_despacho.estado != 'Z'"
                  @click="imprimir_()"
                >
                  <div class="activity-avatar"></div>
                  <div class="activity-info">
                    <span class="font-weight-bold"
                      >Reimprimir Reporte &nbsp; <i class="fas fa-print float-right"></i
                    ></span>
                  </div>
                </button>
                <hr />
                <button
                  class="btn btn-sm btn-block btn-danger"
                  style="margin-top: 0.14rem; padding: 0.4rem"
                  :disabled="validacion_despacho.estado == 'Z'"
                  @click="AnulacionPedido()"
                >
                  <div class="activity-avatar">
                    <i class="fa fa-times"></i>
                  </div>
                  <div class="activity-info">
                    <span class="font-weight-bold">Anular Pedido</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import DynamicService from "@/services/commons/DynamicService";
import EnvioDespachoDetalleComponent from "@/components/wms/envio_despacho/EnvioDespachoDetalleComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";
import ModalPickearComponent from "@/components/wms/envio_despacho/ModalPickearComponent";
import ModalAsignarPlacaComponent from "@/components/wms/envio_despacho/ModalAsignarPlacaComponent";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CajaSelectComponent from "@/components/commons/CajaSelectComponent";

export default {
  components: {
    EnvioDespachoDetalleComponent,
    ModalPickearComponent,
    TiendaSelectComponent,
    ModalAsignarPlacaComponent,
    ExistenciasModalComponent,
    CajaSelectComponent,
  },
  data() {
    return {
      existencias: [],
      barra_posicion: "",
      barra: "",
      placasAsignadas: [],
      errors: "",
      validacion_despacho: "",
      tipo: "FACTURAS",
      seleccionada: null,
      despachos: [],
      nueva_etiqueta: {
        cantidad: 1,
        errors: {
          cantidad: null,
        },
      },
      current_pedido: {},
      id_factura_editar: null,
      filter_estado: "",
      detalle_despacho: [],
      current: {
        scan_barra: true,
        id: null,
        estado_str: null,
        tienda: "",
        estado: "A",
        errors: [],
        bultoe_set: [],
        facturae_set: [],
        recepcionetiqueta_set: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.barrax.focus();
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      this.refreshDespachoE();
    }
  },
  methods: {
    AnulacionPedido() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      $("#modalOpciones").modal("hide");
      let pedido_e = this.seleccionada.id.replace(/-/g, "");
      Notifications.alert.confirm_danger(
        "Anular despacho",
        "Si realiza esta acción ya no podrá continuar con el despacho del producto",
        "Yes",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.validacion_despacho.id,
            "anular_despacho"
          )
            .then((response) => {
              Notifications.alert.success("Anular despacho", "Realizado correctamente");
              setTimeout(() => {
                window.open(
                  `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Devolucion_ProductoND.jrxml&Id=${pedido_e}`
                );
              }, 100);
              self.$router.push({
                path: `/wms/envio-despachos/${"picking-despacho"}/`,
              });
              self.seleccionada = null;
              self.validacion_despacho = null;
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error("Anular picking", error.response.data.detail);
              }
            });
        }
      );
    },
    abrirModalOpciones() {
      $("#modalOpciones").modal("show");
    },
    reabrirPicking() {
      let self = this;
      $("#modalOpciones").modal("hide");
      notifications.alert.confirm(
        "Abrir picking nuevamente",
        "¿Esta seguro?",
        "Yes",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.validacion_despacho.id,
            "abrir_picking"
          )
            .then((response) => {
              Notifications.alert.success("Abrir picking", "Realizado correctamente");
              self.$router.push({
                path: `/wms/despachos/${response.data[0]}/`,
              });
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error("Abrir picking", error.response.data.detail);
              }
            });
        }
      );
    },
    modalAsignarPlaca() {
      $("#modalOpciones").modal("hide");
      $("#modalAsignarPlaca").modal("show");
    },
    verInventarioDeEstacion() {
      $("#modalOpciones").modal("hide");
      $("#modalBarraPosicion").modal("show");
    },
    abrirModalPlaca() {
      $("#modalOpciones").modal("hide");
      $("#modalListaDePlacas").modal("show");
      this.RefreshListaPlacas();
    },
    RefreshListaPlacas() {
      DynamicService.getActionList("wms", "picking-despacho", "mostrar_placas_picking", {
        pedido_e: this.$route.params.id,
      }).then((response) => {
        this.placasAsignadas = response.data;
      });
    },
    imprimir_procter(det) {
      $("#modalOpciones").modal("hide");
      let pedido_e = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=Factura_Carta_mayoreo_agrupado.jrxml&Id=${pedido_e}`
      );
    },
    imprimir_(det) {
      let self = this;
      if (this.seleccionada.observacion != null) {
        self.imprimir_procter(self.$route.params.id);
        return;
      } else {
        self.imprimir(det);
      }
    },
    imprimir(det) {
      $("#modalOpciones").modal("hide");
      let pedido_e = this.seleccionada.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=Factura_Carta.jrxml&Id=${pedido_e}`
      );
      setTimeout(() => {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Devolucion_ProductoND.jrxml&Id=${pedido_e}`
        );
      }, 500);
    },
    facturarDespacho() {
      let self = this;
      Notifications.alert.confirm(
        "Facturar despacho",
        "¿Esta Seguro?",
        "Si Finalizar",
        function () {
          DynamicService.getActionList("wms", "picking-despacho", "finalizar", {
            pedido_e: self.seleccionada.id,
          })
            .then((response) => {
              Notifications.alert.success("Facturar Despacho", "Realizado Exitosamente");
              self.refreshDespachoE();
              if (response.data && response.data.id) {
                self.imprimir();
                return;
              }
              if (response.data && response.data.pedido_e) {
                self.imprimir_procter(response.data.pedido_e);
              }
            })
            .catch((errors) => {
              Notifications.alert.error("Facturar Despacho", errors.response.data.detail);
            });
        }
      );
    },
    finalizarDespacho() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm(
        "finalizar despacho",
        "¿Esta seguro que quiere finalizar el despacho?",
        "Si finalizar",
        function () {
          Notifications.alert.confirm_danger(
            "¡Muy Importante!",
            "Si finaliza el despacho ya no podra volver a modificar nada ni podra habilitarlo de nuevo",
            "Si cerrar",
            function () {
              DynamicService.getActionList("wms", "picking-despacho", "cerrar", {
                pedido_e: self.seleccionada.id,
              })
                .then((response) => {
                  Notifications.alert.success(
                    "Finalizar Despacho",
                    "Realizado Exitosamente"
                  );
                  self.refreshDespachoE();
                })
                .catch((errors) => {
                  Notifications.alert.error(
                    "Finalizar Despacho",
                    errors.response.data.detail
                  );
                });
            }
          );
        }
      );
    },
    cambiarTipoScan() {
      if (this.current.scan_barra == true) {
        this.current.scan_barra = false;
      } else {
        this.current.scan_barra = true;
      }
    },
    buscarPicking() {
      if (this.current.scan_barra == true) {
        if (!this.current.barra) {
          alert("Es necesario el campo de barra");
          return;
        }
        $("#modalCrearTarea").modal("hide");
        this.refreshDespachoE(this.current.barra);
      }
      if (this.current.scan_barra == false) {
        if (!this.current.barra || !this.current.tienda || !this.current.caja) {
          alert("Es necesario llenar todos los campos de busqueda");
          return;
        }
        DynamicService.fetch("wms", "picking-despacho", {
          numero: this.current.barra,
          tienda: this.current.tienda,
          pedido_e__caja: this.current.caja,
        })
          .then((response) => {
            this.current_despacho = response.data.results;
            if (!this.current_despacho[0]) {
              Notifications.alert.error(
                "Buscar despacho",
                "No se encontro ningún despacho"
              );
              return;
            }
            if (this.current_despacho[0]) {
              $("#modalCrearTarea").modal("hide");
              this.refreshDespachoE(this.current_despacho[0].pedido_e);
            }
          })
          .catch((errors) => {
            alert("");
            Notifications.alert.error(
              "Buscar despacho",
              "No se encontro ningún despacho"
            );
          });
      }
    },
    ResetSelect() {
      this.seleccionada = null;
      this.validacion_despacho = null;
      this.$router.push({
        name: "wms-envio-despachos",
        params: {},
      });
    },
    crearTarea() {
      let self = this;
      DynamicService.postActionList("wms", "picking-despacho", "crear_tarea", {
        barra: self.barra,
      })
        .then((response) => {
          Notifications.alert.success("Crear tarea", "Crear tarea correctamente");
          $("#modalCrearTarea").modal("hide");
          self.barra = "";
          this.refreshAll();
        })
        .catch((error) => {
          self.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error("Crear tarea", error.response.data.detail);
          }
        });
    },
    refreshValidacion() {
      DynamicService.fetch("wms", "picking-despacho", {
        pedido_e: this.seleccionada.id,
      })
        .then((response) => {
          this.validacion_despacho = response.data.results[0];
        })
        .catch((error) => {});
    },
    asignarCarrito() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar carrito",
        "¿Esta Seguro(a)?",
        "oki",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "asignar_carrito",
            {
              barra: self.barra,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Asignar carrito",
                "Asignar carrito correctamente"
              );
              $("#modalAggCarrito").modal("hide");
              self.seleccionar(self.seleccionada.id);
              self.barra = "";
            })
            .catch((error) => {
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error("Asignar carrito", error.response.data.detail);
              }
            });
        }
      );
    },
    estacionarProducto() {
      let self = this;
      Notifications.alert.confirm(
        "Estacionar producto de carrito",
        "¿Esta Seguro(a)?",
        "oki",
        function () {
          DynamicService.postAction(
            "wms",
            "picking-despacho",
            self.seleccionada.id,
            "asignar_a_estacion",
            {
              barra: self.barra,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Estacionar producto de carrito",
                "Producto estacionado correctamente"
              );
              $("#modalEstacionarProducto").modal("hide");
              self.seleccionar(self.seleccionada.id);
              self.barra = "";
            })
            .catch((error) => {
              self.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Estacionar producto del carrito",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    refreshDespachoE(id) {
      let self = this;
      if (id) {
        self.$router.push({
          name: "wms-envio-despachos-editar",
          params: { id: id },
        });
      }
      DynamicService.getById("cxc", "pedidos", self.$route.params.id)
        .then((response) => {
          self.seleccionada = response.data;
          this.RefreshDetalleDespacho();
          this.refreshValidacion();
          this.current.barra = "";
        })
        .catch((error) => {
          Notifications.alert.error(
            "Abrir pedido despacho",
            "No se encontro ningún pedido"
          );
        });
    },
    RefreshDetalleDespacho() {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "pedidos",
        self.$route.params.id,
        "mostrar_despachos"
      ).then((response) => {
        self.detalle_despacho = response.data;
      });
    },
    refreshAll() {
      this.refreshDespachoE(this.seleccionada.id);
    },
    deseleccionar() {
      this.seleccionada = null;
    },
    seleccionar(despachoe_id) {
      this.$router.push({ path: `/wms/envio-despachos/${despachoe_id}/` });
      this.refreshDespachoE();
    },
  },
};
</script>
